import { Component, DestroyRef, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { deepMerge } from '../../helpers/deep-merge';
import { STANDARD_REMOTE_URL_PREFIX } from '../../consts';
import { SharedModule } from '@shared/shared.module';
import { RemoteApplicationLoaderService } from '../../remote-application-loader.service';

@Component({
	selector: 'itero-remote-application',
	standalone: true,
	imports: [SharedModule],
	styleUrl: 'remote-application-container.component.scss',
	templateUrl: 'remote-application-container.component.html',
})
export class RemoteApplicationContainerComponent implements OnInit {
	@ViewChild('rootElement', { read: ViewContainerRef, static: true })
	rootElementRef?: ViewContainerRef;

	constructor(
		private readonly activatedRoute: ActivatedRoute,
		private readonly destroyRef: DestroyRef,
		private readonly remoteApplicationLoaderService: RemoteApplicationLoaderService
	) {}

	async ngOnInit(): Promise<void> {
		if (!this.rootElementRef) {
			throw new Error('Container is not initialized');
		}

		const appId = this.activatedRoute.snapshot.url[1]?.path;
		if (!appId) throw new Error('[RemoteApplicationContainerComponent] Missing appId');

		const passedParameters = this.getPassedParameters(history);

		const appParameters = deepMerge(
			{
				appParameters: {
					basePath: `${STANDARD_REMOTE_URL_PREFIX}/${appId}`,
				},
			},
			passedParameters
		) as ApplicationParameters;

		const renderOptions = {
			appId,
			rootElement: this.rootElementRef.element.nativeElement as HTMLElement,
			destroyRef: this.destroyRef,
			appParameters,
		};

		await this.remoteApplicationLoaderService.renderRemote(renderOptions);
	}

	public getPassedParameters(history: History): Record<string, unknown> {
		if (!history.state) return {};
		// Remove the automatically added `navigationId` from the state object
		// eslint-disable-next-line @typescript-eslint/no-unused-vars
		const { navigationId, ...passedParameters } = history.state as Record<string, unknown>;

		return passedParameters;
	}
}

